/**
 * Vue plugin for Authentication
 */
import Authentication from './Authentication'

const AuthPlugin = {
  /**
   * Required opts:
   *  - authStyles object: contains AuthDriver instances
   *  - baseURL string: url to base http requests on
   */
  install(Vue, opts) {
    // reactive interface
    let authInterface = new Vue({
      data: {
        accessToken: null,
        decodedToken: null,
        xsrfToken: null,
        currentAuthStyle: null
      }
    })
    // changes a data property on the vue store, will be reactive
    opts.reactiveChange = (property, value) => {
      authInterface.$data[property] = value
    }
    // initialize Authentication manager
    Vue.Authentication = new Authentication(opts)
    // attach http object to vue prototype
    Vue.prototype.$http = Vue.Authentication.http
    // attach auth interface to vue prototype
    Vue.prototype.$auth = {
      login(style) {
        Vue.Authentication.login(style)
      },
      async backgroundLogin() {
        let resp = await Vue.Authentication.backgroundLogin()
        Vue.prototype.$http = Vue.Authentication.http
        return resp
      },
      logout() {
        Vue.Authentication.logout()
      },
      async refreshToken() {
        return await Vue.Authentication.refreshToken(Vue.prototype.$http);
      },
      get styles() {
        return Vue.Authentication.styles
      },
      get currentAuthDriver() {
        return Vue.Authentication.currentAuthDriver
      },
      get currentAuthStyle() {
        return authInterface.$data.currentAuthStyle
      },
      get accessToken() {
        return authInterface.$data.accessToken
      },
      get decodedToken() {
        return authInterface.$data.decodedToken
      },
      get xsrfToken() {
        return authInterface.$data.xsrfToken
      }
    }
  }
}

export {
  AuthPlugin,
  AuthPlugin as
  default
}
